import axios, { AxiosResponse } from 'axios';

export const getComments = (id: string): Promise<AxiosResponse> =>
	axios.get(`/comments/${id}`);

export const addComment = (body: any): Promise<AxiosResponse> =>
	axios.post(`/comments`, body);
